<template>
  <div class="th-list-course">
    <h2 class="th-title"><b>Data Center Dashboard</b></h2>

    <a-card>
      <div class="mb-3 row">
        <div class="col-3 m-1">
          <a-input-search placeholder="Cari Nama Lokasi..." v-model:value="search" />
        </div>
        <div class="col m-1 w-100 d-flex justify-content-end align-items-center">
          <router-link to="/base/lokasi/buat">
            <a-button> <PlusOutlined />Lokasi Baru </a-button>
          </router-link>
        </div>
      </div>
      <div class="w-100" style="overflow-x:auto ;">
        <a-table
          :pagination="globalPagination"
          :columns="columns"
          :data-source="filteredData"
          class="table"
          bordered
          table-layout="auto"
          :loading="loadingTable"
          @change="handleTableChange"
        >
          <template #customer="{ record }">
            <router-link
              class="th-link"
              :to="{
                name: 'Detail Base Lokasi',
                params: { id: record.id },
              }"
            >
              {{ record.Customer.name }}
            </router-link>
            <p class="text-mute">
              {{ record.Customer.customerSign }}
            </p>
          </template>

          <template #location="{ record }">
            {{ record.name }}
          </template>

          <template #description="{ record }">
            {{ record.notes }}
          </template>

          <template #action="{ record }">
            <a-button type="danger" @click="openDeleteModal(record.id)">
              <RestOutlined :style="{ color: 'white' }" />
            </a-button>
          </template>
        </a-table>
      </div>
    </a-card>

    <a-modal
      v-model:visible="isDeleteModalVisible"
      title="Konfirmasi Penghapusan"
      ok-text="Hapus"
      ok-type="danger"
      cancel-text="Batal"
      centered
      @ok="handleDelete"
      @cancel="closeDeleteModal"
    >
      <p>
        Apakah Anda yakin ingin menghapus lokasi ini? Data aset yang berada di lokasi ini mungkin
        akan terpengaruh.
      </p>
    </a-modal>
  </div>
</template>

<script>
import { onMounted, ref, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { notification } from 'ant-design-vue'
import { PlusOutlined, RestOutlined } from '@ant-design/icons-vue'
import { getLocations, deleteLocations } from '../../../services/axios/modc/users'

const columns = [
  {
    title: 'CUSTOMER',
    dataIndex: 'customer',
    key: 'customer',
    slots: { customRender: 'customer' },
    width: 200,
  },
  {
    title: 'LOCATION',
    dataIndex: 'location',
    key: 'location',
    slots: { customRender: 'location' },
  },
  {
    title: 'DESCRIPTION',
    dataIndex: 'description',
    key: 'description',
    slots: { customRender: 'description' },
  },
  {
    title: 'Action',
    key: 'action',
    slots: { customRender: 'action' },
    align: 'center',
    width: 100,
  },
]

export default {
  components: {
    PlusOutlined,
    RestOutlined,
  },
  setup() {
    const router = useRouter()
    const loadingTable = ref(false)
    const search = ref('')
    const masterData = ref([])
    const globalPagination = ref({ current: 1, pageSize: 10 })

    // State untuk mengontrol modal
    const isDeleteModalVisible = ref(false)
    const locationIdToDelete = ref(null)

    // Computed property untuk filter lokal
    const filteredData = computed(() => {
      const searchTerm = search.value.toLowerCase()
      if (!searchTerm) {
        return masterData.value
      }
      return masterData.value.filter(
        item =>
          (item.name && item.name.toLowerCase().includes(searchTerm)) ||
          (item.Customer?.name && item.Customer.name.toLowerCase().includes(searchTerm)),
      )
    })

    const fetchLocations = async () => {
      loadingTable.value = true
      try {
        const data = await getLocations()
        masterData.value = data.locations.map((loc, index) => ({
          ...loc,
          key: index + 1,
        }))
        globalPagination.value.total = data.locations.length
      } catch (error) {
        console.error('Gagal mengambil data lokasi:', error)
        notification.error({
          message: 'Gagal Memuat Data',
          description: 'Terjadi kesalahan saat mengambil daftar lokasi.',
        })
      } finally {
        loadingTable.value = false
      }
    }

    onMounted(fetchLocations)

    watch(search, () => {
      // Karena filter dilakukan secara lokal, tidak perlu memanggil API lagi
      // Cukup reset pagination ke halaman pertama
      globalPagination.value.current = 1
    })

    const deleteLocationFunc = async locationId => {
      try {
        await deleteLocations(locationId)
        notification.success({
          message: 'Berhasil',
          description: 'Lokasi telah berhasil dihapus.',
        })
        await fetchLocations() // Muat ulang data setelah sukses
      } catch (error) {
        console.error('Gagal menghapus lokasi:', error)
        notification.error({
          message: 'Gagal Menghapus',
          description: 'Terjadi kesalahan saat mencoba menghapus lokasi.',
        })
      }
    }

    const openDeleteModal = locationId => {
      locationIdToDelete.value = locationId
      isDeleteModalVisible.value = true
    }

    const closeDeleteModal = () => {
      isDeleteModalVisible.value = false
      locationIdToDelete.value = null
    }

    const handleDelete = () => {
      if (locationIdToDelete.value) {
        deleteLocationFunc(locationIdToDelete.value)
      }
      closeDeleteModal()
    }

    const handleTableChange = pag => {
      globalPagination.value.current = pag.current
    }

    return {
      search,
      columns,
      filteredData,
      loadingTable,
      globalPagination,
      handleTableChange,
      isDeleteModalVisible,
      openDeleteModal,
      closeDeleteModal,
      handleDelete,
    }
  },
}
</script>
<style lang="scss">
@import '@/views/styleViews.scss';

.text-customer {
  font-size: 0.75rem;
}

.th-list-course {
  .th-link {
    color: var(--vb-color-primary) !important;

    &:hover {
      color: var(--kit-color-primary) !important;
    }
  }
}
</style>
